import React, {
	useState,
	useRef,
	useEffect
} from "react";
import PropTypes from 'prop-types';
import { DropzoneAreaBase } from 'mui-file-dropzone'

import {
	Grid,
	Box,
	Button,
} from "@mui/material";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";

import {
	trakrefFontFamily,
	trakrefFontFamilySemiBold,
} from "../../../utils";
import {
	Grey2,
	Grey3,
	trakrefBlue
} from "../../../color_utils";
import CommonModal from "../CommonModal";
import LoadingButtonV4 from "../LoadingButtonV4";

const ColoredUploadIcon = () => (
	<FileUploadOutlinedIcon
		fontSize="large"
		sx={{
			color: trakrefBlue,
			marginTop: "25px",
		}}
	/>
);

const BulkModal = ({
	open,
	onClose,
	onClick,
	header,
	buttonText,
	loading
}) => {
	const dropzoneRef = useRef();
	const [fileUploaded, setFileUploaded] = useState(null);

	useEffect(() => {
		setFileUploaded(null);
	}, [open])

	return (
		<CommonModal open={open} close={onClose} header={header}>
			<Grid container pl={10} pr={10} gap={1}>
				<div style={{ textAlign: "center" }}>
					<span
						style={{
							fontSize: "13px",
							display: "inline-block",
							fontFamily: trakrefFontFamilySemiBold,
						}}
					>
						Download and complete the template provided. Instructions are available in the document. File formats accepted are .xlsx and .xlsm.
					</span>
				</div>
				<Grid item xs={12} lg={12}>
					<Box
						sx={{
							position: "relative",
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							flexDirection: "column",
							gap: "10px",
							padding: "10px",
						}}
					>
						<DropzoneAreaBase
							showPreviewsInDropzone={false}
							showAlerts={false}
							onAdd={fileObjs => setFileUploaded(fileObjs[0])}
							dropzoneProps={{ ref: dropzoneRef }}
							filesLimit={1}
							Icon={ColoredUploadIcon}
							dropzoneText=""
						/>
						<div
							style={{
								position: "absolute",
								top: "110px",
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
								flexDirection: "column",
								gap: "0px",
							}}
						>
							<span
								sx={{
									fontFamily: trakrefFontFamilySemiBold,
									color: Grey2,
									fontSize: 15,
									letterSpacing: "1px",
								}}
							>
								Drag and Drop a file here
							</span>
							<span
								style={{
									fontFamily: trakrefFontFamilySemiBold,
									color: Grey2,
									fontSize: 13,
								}}
							>
								or
							</span>
						</div>
						<Button
							variant="outlined"
							size="small"
							style={{
								fontSize: "14px !important",
							}}
							sx={{
								borderColor: trakrefBlue,
								borderWidth: "1.5px",
								color: trakrefBlue,
								fontFamily: trakrefFontFamily,
								letterSpacing: "1.5px",
								fontWeight: "600",
								marginBottom: "20px",
								position: "absolute",
								bottom: "60px",
								background: "transparent",
							}}
							onClick={() => dropzoneRef.current.open()}
						>
							BROWSE FILES
						</Button>
					</Box>
					{fileUploaded && (
						<span
							style={{
								color: Grey3,
								fontSize: "12px",
								marginLeft: "10px",
							}}
						>
							{`${fileUploaded.file.name} - ${fileUploaded.file.size} bytes`}
						</span>
					)}
				</Grid>
				<Grid item xs={12} lg={12} align="center">
					<Box mt={2} mb={2} sx={{ width: "100%", paddingLeft: "10px", paddingRight: "10px" }}>
						<LoadingButtonV4
							buttonText={buttonText}
							onClick={() => onClick(fileUploaded)}
							loading={loading}
							disabled={!fileUploaded}
						/>
					</Box>
				</Grid>
			</Grid>
		</CommonModal>
	);
};

BulkModal.propTypes = {
	open: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	onClick: PropTypes.func.isRequired,
	header: PropTypes.string,
	buttonText: PropTypes.string,
	loading: PropTypes.bool,
};

BulkModal.defaultProps = {
	header: "Bulk Import",
	buttonText: "Upload",
	loading: false
};

export default BulkModal;
